export const actions = {
    actSetClientSize({commit},size){
        commit('setClientSize',size)
    }
}
